export default __webpack_public_path__ + "media/images/flaticons/support-742caae5101d98ae2c4942c5ddccecc4.png";